export const iconFontAwesomeMapsInfo = (
	<i className="fa-solid fa-info"></i>
);
